let React = require("react");

let Toast = require("../../Toast.jsx");

let ContentServerClient =  require("../../../ContentServerClient.js");

class UndeleteHubToast extends React.Component {

    constructor(){
        super();

        this.state = {}

        this.undeleteHub = this.undeleteHub.bind(this);
    }

    undeleteHub(){
        const {setLoading, history, handleError, currentHub, checkHubsAvailability} = this.props;

        checkHubsAvailability(() => {
            setLoading(true, "Restoring...");

            // custom error here

            ContentServerClient.undeleteHub(handleError, currentHub.id)
            .then(()=>{
                setLoading(false);
                history.push(`/hubs/${currentHub.id}`);
            })
            .catch(()=>setLoading(false));
        })

    }

    render() {
        const {currentHub} = this.props;

        return  <Toast resizeToastContainer={this.props.resizeToastContainer} hasClose={false} show={currentHub && currentHub.deleted} toastName="undelete" type="warning">
                        <div className="contInvitation">
                            <p className="text">This {hubAlias} has been <b>deleted</b>.  Data inside a deleted {hubAlias} cannot be edited or shared.</p>
                            <div className="contOptions">
                                <button className="button transparent" onClick={this.undeleteHub}>Restore</button>
                            </div>
                        </div>
                </Toast>
    }
}

module.exports = UndeleteHubToast;
